// Lightbox — fullscreen preview portal for a single image/video url.
// Extracted verbatim from ImageAnimatorModal.jsx:3929-3990 (no behaviour change).

import { useMemo } from "react";
import { createPortal } from "react-dom";
import { LuX } from "react-icons/lu";

export default function Lightbox({ url, onClose }) {
  // A play-once webp/gif that already finished stays on its last frame when the
  // same URL is shown again, so every open gets its own URL. url goes
  // null -> value on each open, so this recomputes per open.
  const imgSrc = useMemo(() => {
    if (!url || !/\.(webp|gif)(\?|$)/i.test(url)) return url;
    return `${url}${url.includes("?") ? "&" : "?"}__t=${Date.now()}`;
  }, [url]);

  if (!url) return null;

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.88)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 3000060, // above the whole dialog band incl. pageModal (3000030) and fileModal (3000040)
        cursor: "zoom-out",
      }}
    >
      {/\.(mp4|webm)(\?|$)/i.test(url) ? (
        <video
          src={url}
          autoPlay
          loop
          controls
          playsInline
          onClick={(e) => e.stopPropagation()}
          style={{
            maxWidth: "90vw",
            maxHeight: "90vh",
            objectFit: "contain",
            borderRadius: 8,
            cursor: "default",
          }}
        />
      ) : (
        <img
          src={imgSrc}
          alt="Fullscreen"
          onClick={(e) => e.stopPropagation()}
          style={{
            maxWidth: "90vw",
            maxHeight: "90vh",
            objectFit: "contain",
            borderRadius: 8,
            cursor: "default",
          }}
        />
      )}
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          background: "rgba(255,255,255,0.15)",
          border: "none",
          borderRadius: "50%",
          width: 38,
          height: 38,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          cursor: "pointer",
          backdropFilter: "blur(4px)",
        }}
      >
        <LuX size={18} />
      </button>
    </div>,
    document.body
  );
}
